import { processModel } from "@/_core/data/api_calls/relatives_values/model/processModel";

/**
 * Retrieves model data for commodity relative values
 * @param {object} ctx: context variables
 * @param {object} assetExtraParams: extra parameters for query
 */
export function getModelDataCommodities(ctx, assetExtraParams) {
  let params = {
    method: "GET",
    endpoint: "relatives_values_commodities",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: assetExtraParams.commodityNumber,
      contract: assetExtraParams.contract
    }
  };
  return processModel(ctx, params);
}
